var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9907 8.15689H9.61551C6.89609 8.15689 4.68154 5.93446 4.68154 3.20537V0.833252H7.28622V3.21689C7.28622 4.50659 8.33038 5.54295 9.60404 5.54295H11.9792V8.15689H11.9907Z",
    fill: "#062021"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64365 12.8665H5.34705V8.82471L4.0275 7.50047H0V6.18774H4.56679L6.64365 8.2835V12.8665Z",
    fill: "#062021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9bea65a077a61ba358d596bdaf7f3f8d.svg";
export { ForwardRef as ReactComponent };